import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface DialogGoBack extends SVGProps<SVGSVGElement> {
  label?: string
}

const DialogGoBack: React.FC<DialogGoBack> = ({
  label = 'dialogGoBack',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="dialog-go-back-svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16.5" r="16" fill="#F7F3F8" />
        <path
          d="M11.828 15.5H24V17.5H11.828L17.192 22.864L15.778 24.278L8 16.5L15.778 8.72198L17.192 10.136L11.828 15.5Z"
          fill="#1A0244"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default DialogGoBack
